import { css } from 'react-emotion';
import { fontFamily, colors, heights, animationTransition } from '../../variables';

export namespace styles {
  export const dropdownWrapper = css({
    width: '100%'
  });

  export const toggle = css({
    fontFamily,
    backgroundColor: '#fff',
    height: heights.INPUT_HEIGHT,
    border: '1px solid',
    borderColor: colors.light,
    borderRadius: '.3rem',
    padding: '.65rem 1rem',
    margin: '8px 0',
    fontSize: '1rem',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer'
  });

  export const arrowUp = css({
    width: 0,
    height: 0,
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderBottom: '5px solid black'
  });

  export const arrowDown = (open: boolean) =>
    css({
      width: 0,
      height: 0,
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderTop: '5px solid black',
      transition: animationTransition('transform'),
      transform: open ? `rotate(180deg)` : 'rotate(0deg)'
    });

  export const rowWrapper = css({
    position: 'relative',
    width: '100%'
  });

  export const rowWrapperFixed = css({
    width: '100%',
    maxHeight: heights.INPUT_HEIGHT * 4,
    overflowY: 'scroll',
    position: 'absolute',
    left: 0,
    top: -17
  });

  export const row = (groupFirst: boolean = false, groupLast: boolean = false, isActive: boolean = false) =>
    css({
      fontFamily,
      backgroundColor: isActive ? '#fff' : '#fff',
      height: heights.INPUT_HEIGHT,
      borderColor: colors.light,
      borderRadius: '.3rem',
      padding: '.25rem 0',
      marginTop: groupLast ? '8px' : '',
      marginBottom: groupFirst ? '8px' : '',
      margin: 0,
      fontSize: '1rem',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxSizing: 'border-box',
      cursor: 'pointer'
    });
}
